<template>
  <div>
    <CContainer>
      <CRow>
        <CCol md="12">
          <CCard>
            <CCardBody>
              <CInput
                label="Section Title"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the section title."
                v-model="sectionTitle"
                :is-valid="sectionTitleValidator"
                placeholder="e.g. Artificial Flower"
              />
              <CInput
                label="Section Chinese Title"
                v-model="chineseTitle"
                placeholder="例如: 仿真花"
              />
              <p>Product List</p>
              <CRow class="mb-3">
                <CCol
                  sm="3"
                  v-for="(data, index) in isFilled"
                  :key="index"
                >
                  <div v-if="data">
                    <CCard class="pointer">
                      <CCardBody class="p-2">
                        <CImg 
                          alt="Product Image" 
                          :src="data.image" 
                          class="w-100 mb-3"
                        />
                        <CCardSubtitle class="mb-3">{{ data.name }}</CCardSubtitle>
                        <CCardSubtitle>{{ moneyFormatter(data.price) }}</CCardSubtitle>
                      </CCardBody>
                    </CCard>
                  </div>
                  <div v-else>
                    <CButton 
                      block 
                      shape="pill" 
                      color="light" 
                      @click="() => { 
                        modalVisible.search = true 
                        fillIndex = index
                      }"
                    >
                      <div class="button-text">
                        <CIcon name="cil-plus" />
                        <span><b>Search Product</b></span>
                      </div>
                    </CButton>
                  </div>
                </CCol>
              </CRow>
              <CInput
                label="Button Text"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the button's text."
                v-model="button.text"
                :is-valid="buttonTextValidator"
                placeholder="e.g. VIEW ALL PRODUCTS"
              />
              <CInput
                label="Chinese Button Text"
                v-model="button.chineseText"
                placeholder="例如：查看所有商品"
              />
              <CInput
                label="Button Redirect Link"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the button's redirect link."
                v-model="button.redirectUrl"
                :is-valid="buttonRedirectUrlValidator"
                placeholder="e.g. https://google.com"
              />
            </CCardBody>
            <CCardFooter>
              <CButton class="mr-2" color="primary" :disabled="!isValidatePass" @click="handleCreate">
                <span>Save</span>
              </CButton>
              <CButton color="danger" @click="() => { $router.back() }">
                <span>Cancel</span>
              </CButton>
            </CCardFooter>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal
      title="Modal title"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="modalVisible.search"
      size="lg"
    >
      <CRow>
        <CCol :sm="12">
          <CInput placeholder="Product Name" v-model="keyword">
            <template #append>
              <CButton color="primary" @click="searchProductByName">
                <CIcon name="cil-magnifying-glass"/> Search
              </CButton>
            </template>
          </CInput>
        </CCol>
      </CRow>
      <CRow v-if="searchList.length">
        <CCol
          v-for="data in searchList"
          :key="data.id"
          sm="3"
        >
          <CCard class="pointer" @click="handleSelectProduct(data)">
            <CCardBody class="p-2">
              <CImg 
                alt="Product Image" 
                :src="data.image[0]" 
                class="w-100 mb-3"
              />
              <CCardSubtitle class="mb-3">{{ data.name }}</CCardSubtitle>
              <CCardSubtitle>{{ moneyFormatter(data.price) }}</CCardSubtitle>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Product List</h5>
        <CButtonClose @click="dismissModal" />
      </template>
      <template #footer>
        <div></div>
      </template>
    </CModal>
  </div>
</template>

<script>
import {
  SHOWCASE_CREATE,
  PRODUCT_GET_BY_NAME,
} from '../../../../constants/api'
import moneyFormatter from '../../../../utils/moneyFormatter'

import axios from 'axios'

export default {
  data () {
    return {
      moneyFormatter,
      sectionTitle: '',
      chineseTitle: '',
      isFilled: [false, false, false, false],
      list: [],
      button: {
        text: '',
        chineseText: '',
        redirectUrl: '',
      },
      validatePass: {
        sectionTitle: false,
        buttonText: false,
        buttonRedirectUrl: false,
      },
      modalVisible: {
        search: false,
      },
      keyword: '',
      searchList: [],
      fillIndex: -1,
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },

  computed: {
    isValidatePass () {
      return this.validatePass.sectionTitle && this.validatePass.buttonText && this.validatePass.buttonRedirectUrl && this.list.length === 4
    }
  },

  methods: {
    searchProductByName () {
      if (!this.keyword.length) return

      axios.get(`${PRODUCT_GET_BY_NAME}`, {
        headers: {
          'x-access-token': this.accessToken
        },
        params: {
          limit: 8,
          name: this.keyword,
        }
      })
        .then(res => {
          this.searchList = res.data.data
          this.keyword = ''
        })
    },

    handleCreate () {
      const payload = {
        showcaseData: JSON.stringify({
          sectionTitle: this.sectionTitle,
          chineseTitle: this.chineseTitle,
          list: this.list,
          button: {
            text: this.button.text,
            chineseText: this.button.chineseText,
            redirectUrl: this.button.redirectUrl
          }
        })
      }
      axios.put(`${SHOWCASE_CREATE}`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(() => this.$router.back())
    },

    dismissModal () {
      this.fillIndex = -1
      this.keyword = ''
      this.searchList = []
      this.modalVisible.search = false
    },

    handleSelectProduct (product) {
      this.isFilled[this.fillIndex] = {
        name: product.name,
        price: product.price,
        image: product.image[0]
      }
      this.list.push(product.id)
      this.dismissModal()
    },
    
    // validator
    sectionTitleValidator (val) {
      if (val.length > 0) {
        this.validatePass.sectionTitle = true
        return true
      } else {
        this.validatePass.sectionTitle = false
        return false
      }
    },
    
    buttonTextValidator (val) {
      if (val.length > 0) {
        this.validatePass.buttonText = true
        return true
      } else {
        this.validatePass.buttonText = false
        return false
      }
    },
    
    buttonRedirectUrlValidator (val) {
      if (val.length > 0) {
        this.validatePass.buttonRedirectUrl = true
        return true
      } else {
        this.validatePass.buttonRedirectUrl = false
        return false
      }
    },
  }
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
  .pointer {
    cursor: pointer;
  }
</style>